import { SyntheticEvent, useEffect, useRef, useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { FormattedMessage, useIntl } from 'react-intl';

import { FormMsg, NoFormMsg } from 'components/forms/FormMessage';
import { ModalDialog } from 'components/modal/Modal';

type CreateFolderFormProps = {
  onSubmit: (name: string) => number | Promise<number>;
  // 201 = Folder created
  // 409 = Folder already exists
  // 422 = Invalid folder name provided
};

export default function CreateFolderForm(props: CreateFolderFormProps) {
  const { onSubmit } = props;
  const intl = useIntl();
  const [data, setData] = useState({ name: '' });
  const [validForm, setValidForm] = useState<boolean>(true);
  const [formMsg, setFormMsg] = useState<FormMsg>(NoFormMsg);
  const inputRef = useRef<HTMLInputElement>(null);
  const [formSubmitted, setFormSubmitted] = useState<boolean>(false);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  async function handleSubmit(): Promise<boolean> {
    if (formSubmitted) {
      return true;
    }
    const status = await onSubmit(data.name);
    switch (status) {
      case 201:
        // setFormSubmitted(true);
        // setFormMsg({
        //   message: intl.formatMessage({ id: 'LIBRARY.FOLDERS.SUCCESS' }),
        //   success: true,
        //   timeout: 2000,
        // });
        return true;
      case 409:
        setFormMsg({
          message: intl.formatMessage({ id: 'LIBRARY.FOLDERS.CONFLICT' }),
          success: false,
          timeout: 3000,
        });
        break;
      case 422:
        setFormMsg({
          message: intl.formatMessage({ id: 'LIBRARY.FOLDERS.INVALID' }),
          success: false,
          timeout: 3000,
        });
        break;
    }
    return false;
  }

  function handleChangeData(e: SyntheticEvent) {
    const target = e.target as HTMLInputElement;
    setData({
      ...data,
      [target.name]: target.value,
    });
  }

  return (
    <ModalDialog
      className="settings_form narrow"
      title={<FormattedMessage id="LIBRARY.FOLDERS.CREATE" />}
      okBtn={{
        onClick: handleSubmit,
      }}
      cancelBtn={{}}
      enableEscape
      formMsg={formMsg}
      validated={!validForm}
      setValidForm={setValidForm}
      // delayCloseOnSuccess={2000}
    >
      <Form.Group as={Row} controlId="folderName">
        <Col sm={12} md={12} lg={12}>
          <Row className="subrow">
            <Form.Control
              className="field"
              type="text"
              placeholder={intl.formatMessage({
                id: 'LIBRARY.FOLDERS.NAME',
              })}
              name={'name'}
              value={data.name || ''}
              onChange={handleChangeData}
              required
              ref={inputRef}
            />
            <Form.Control.Feedback type="invalid">
              <FormattedMessage id="LIBRARY.FOLDERS.REQUIRED" />
            </Form.Control.Feedback>
          </Row>
        </Col>
      </Form.Group>
    </ModalDialog>
  );
}
